import React from 'react';
import PropTypes from 'prop-types';
import { UiButton, UiIcon } from 'ui-components';
import { getDateTime, getEnv } from 'utils';
import classNames from 'classnames';
import CopyToClipboard from 'components/copy-to-clipboard/CopyToClipboard';
import { useTranslation } from 'react-i18next';
import { StyledPdfNotif } from './PdfNotif.styles';

const PdfNotif = (props) => {
  const {
    file_name,
    status,
    title,
    time: dateTime,
    dl_url = null,
    isRead,
  } = props;
  const { t } = useTranslation();
  const { date, time } = getDateTime(dateTime);

  const getBulletinDownloadUrl = () => {
    if (dl_url) return dl_url;

    return `${getEnv(
      'REACT_APP_BASE_API'
    )}/bulletin/v2/export/download?file_name=${file_name}`;
  };

  return (
    <StyledPdfNotif>
      <div className={classNames('pdf-notif')}>
        <div className='flex gap-10'>
          {/* نقطه اول خط */}
          {!isRead && <span className='bullet'></span>}

          {/* آیکن pdf */}
          <UiIcon icon='ri-file-pdf-line' color='#4C6FFF' hover='#4C6FFF' />

          {/* متن پیشفرض */}
          <span className='file-is-ready'>
            {t('notifications:blulletinExportedFileIsReady')}
          </span>

          {/* تاریخ دریافت */}
          <bdi className='date-time'>
            <span className='mr-5'>{date}</span>
            {time}
          </bdi>
        </div>

        {/* عنوان بولتن */}
        <h3 className='file-name'>{title}</h3>

        {/* دکمه دانلود */}
        <div className='flex'>
          <UiButton
            variant='outlined'
            disabled={status !== 4}
            fullWidth
            target='_blank'
            href={getBulletinDownloadUrl()}
          >
            <div className='flex between'>
              <UiIcon
                icon='ri-file-pdf-line'
                color='#199DA3'
                hover='#199DA3'
                className='ml-10'
              />
              <span>{t('notifications:downloadPDFFile')}</span>
            </div>
          </UiButton>
          <CopyToClipboard
            text={getBulletinDownloadUrl()}
            className='fullwidth'
          >
            <UiButton
              variant='outlined'
              className='copy-link-btn'
              color='primary'
              fullWidth
            >
              {t('notifications:copyLinkAddress')}
            </UiButton>
          </CopyToClipboard>
        </div>
      </div>
    </StyledPdfNotif>
  );
};

PdfNotif.propTypes = {
  file_name: PropTypes.string,
  status: PropTypes.number,
  title: PropTypes.string,
  dl_url: PropTypes.string,
  time: PropTypes.string,
  isRead: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
};

export default PdfNotif;
